<template>
	<v-card v-if="item">
		<v-container>
			<v-layout align-center justify-space-between wrap class="mb-2">
				<h2 class="title">{{item.title}}</h2>
				<navigation :id="item.id" />
			</v-layout>
			<p class="body-1">Hinweis: {{item.text}}</p>
			<contact-form></contact-form>
		</v-container>
	</v-card>
</template>

<script>
import ContactForm from './ContactForm.vue';
import Navigation from './Navigation.vue';

export default {
	components: {
		ContactForm,
		Navigation,
	},
	props: ['item'],
};
</script>
